import { setComponentMapOverrides } from '@jutro/uiconfig';

import { PaymentDetailsPage, QualificationPage } from 'gw-capability-quoteandbind-common-react';

import BAYourInfoPage from './pages/YourInfo/YourInfoPage';
import BADriversPage from './pages/Drivers/DriversPage';
import BAVehiclesPage from './pages/Vehicles/VehiclesPage';
import BADriverAssignmentPage from './pages/DriverAssignment/DriverAssignmentPage';
import BARiskAnalysisPage from './pages/RiskAnalysis/RiskAnalysisPage';
import BAQuotePage from './pages/Quote/QuotePage';
import BAAdditionalInformation from './pages/AdditionalInformation/AdditionalInformationPage';
import BAPolicyInformationPage from './pages/PolicyInformation/PolicyInformationPage';
import BASuccessPage from './pages/Success/SuccessPage';

setComponentMapOverrides(
    {
        BAYourInfoPage: { component: 'BAYourInfoPage' },
        BAQualificationPage: { component: 'BAQualificationPage' },
        BADriversPage: { component: 'BADriversPage' },
        BAVehiclesPage: { component: 'BAVehiclesPage' },
        BADriverAssignmentPage: { component: 'BADriverAssignmentPage' },
        BARiskAnalysisPage: { component: 'BARiskAnalysisPage' },
        BAQuotePage: { component: 'BAQuotePage' },
        BAAdditionalInformation: { component: 'BAAdditionalInformation' },
        BAPolicyInformationPage: { component: 'BAPolicyInformationPage' },
        BAPaymentDetailsPage: { component: 'BAPaymentDetailsPage' },
        BASuccessPage: { component: 'BASuccessPage' }
    },
    {
        BAYourInfoPage,
        BAQualificationPage: QualificationPage,
        BADriversPage,
        BAVehiclesPage,
        BADriverAssignmentPage,
        BARiskAnalysisPage,
        BAQuotePage,
        BAAdditionalInformation,
        BAPolicyInformationPage,
        BAPaymentDetailsPage: PaymentDetailsPage,
        BASuccessPage
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as BAWizard } from './BAWizard';
